// Auto generated file, do not manually modify!
// com.hotpads.leasing.api.web.v1.signing.LeasingUserSigningOuidWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid,
  LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid,
  LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_Path,
} from '@zg-rentals/ts-leasing-client';

import type { WhoHasSignedFromOuidWebApiResponseDto } from '@zg-rentals/ts-leasing-client';

interface MarkAsSignedFromOuidParams {
  ouid: string;
}
interface WhoHasSignedFromOuidParams {
  ouid: string;
}

export interface LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid_Args {
  getParams: MarkAsSignedFromOuidParams;
}

export type LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid_Options = UseMutationOptions<
  void,
  unknown,
  LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid_Args
>;

/**
 * marks the lease as signed for user from ouid
 */
export const useLeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid = ({
  httpClient,
  ...options
}: Omit<LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid_Args) =>
      LeasingUserSigningOuidWebApiHandler_markAsSignedFromOuid(args.getParams, httpClient),
  });
};

export type LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_Options = UseQueryOptions<
  WhoHasSignedFromOuidWebApiResponseDto,
  unknown,
  WhoHasSignedFromOuidWebApiResponseDto,
  readonly [string, WhoHasSignedFromOuidParams]
>;

const LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_GetKey = (getParams: WhoHasSignedFromOuidParams) =>
  [LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_Path, getParams] as const;

export const LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_queryOptions = (
  getParams: WhoHasSignedFromOuidParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_GetKey(getParams),
    queryFn: () => LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * get list of users for signing with ouid to reset tenant association
 */
export const useLeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid = (
  getParams: WhoHasSignedFromOuidParams,
  {
    httpClient,
    ...options
  }: Omit<LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useLeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid.getKey =
  LeasingUserSigningOuidWebApiHandler_whoHasSignedFromOuid_GetKey;
